import { BaseButtonProps } from '@/components/Button';
import { DateGDT, GDTApiErrors } from '.';
import { ReactNode } from 'react';
import { STATUS_TOURNEY_INVITATION } from '../utils/constants';
import { ResponseBase } from './commons';

export interface ResponseListTDAP {
  participaciones: any[];
  llenoFormBancario: boolean;
  estado: boolean;
  db_readOnly: boolean;
  tengoPinDisponible: boolean;
  abiertos: Abierto[];
  tieneDB: boolean;
  readOnly: boolean;
  muestroPopUpDatosBancarios: boolean;
}

export interface Abierto {
  nombre: string;
  id: number;
  cantPart: number;
  idTipoPin: number;
  nombreFecha: string;
  gratuitaFueUsada: boolean;
  premio: number;
  fechaInicio: FechaInicio;
  usoPinDeCD: boolean;
  type: string;
}

export interface FechaInicio {
  id: number;
  nombre: string;
  orden: number;
  isPublicada: boolean;
}

export interface ResponseInitTDA {
  estado: boolean;
  torneos_amigo: TorneosAmigo;
  cantTasAnteriores: number;
}

export interface TorneosAmigo {
  participando: ParticipandoTda[];
  pendientesAcDuenio: PendientesTda[];
  cantidadTotalTorneos: number;
}

export interface PendientesTda {
  id: number;
  mostrarAccionPendienteAceptacion: boolean;
  nombre: string;
  ordenFecha: number;
  nombreDuenio: string;
  owner: boolean;
  rechazado: boolean;
  supercopa: boolean;
  vip: boolean;
  cantidadParticipantes?: number;
}

export interface ParticipandoTda {
  id: number;
  nombre: string;
  vip: boolean;
  owner: boolean;
  nombreDuenio: string;
  mostrarAccionPendienteAceptacion: boolean;
  ordenFecha: number;
  supercopa: boolean;
  cantidadParticipantes: number;
  tda: any;
}

export interface AdminItemParticipando {
  idUsuario: number;
  nombreEquipo: string;
  nombreYApellido: string;
  nombreProvincia?: string;
  fotoPerfil?: string;
}

export interface ResponseThumbsParticipants {
  totalParticipantes: number;
  participantes: {
    nombreUsuario: string;
    nombreEquipo: string;
    fotoPerfil?: string;
    nombreProvincia?: string;
  }[];
}

export interface ResponseSuggestionAutocomplete {
  estado: boolean;
  sugerencias: Suggestion[];
}

export interface Suggestion {
  texto: string;
  tipo: string;
}

export interface ResponseTourneysExisting {
  estado: true;
  total: number;
  page: PageResponseTourneysExisting;
  paginaActual: number;
  cantPorPagina: number;
  nombreTorneo: string;
  nombreDueno: string;
  apellidoDueno: string;
}

export interface PageResponseTourneysExisting {
  objectList: ItemResponseTourneyExisting[];
  pageCount: number;
  currentPage: number;
  hasNext: boolean;
  hasPrevious: boolean;
  pagerInfo: PagerInfo;
  objectCount: number;
}

export interface ItemResponseTourneyExisting {
  apellidoUsuarioOwner: string;
  cantidadParticipantes?: number;
  nombreProvincia?: string;
  fechaCreacion: string;
  idTorneo: number;
  idTorneoAmigos: number;
  fotoPerfil?: string;
  idUsuarioOwner: number;
  nombreTorneoAmigos: string;
  nombreUsuarioOwner: string;
  ordenFecha: number;
  privado: boolean;
  vip: boolean;
}
export interface PagerInfo {
  length: number;
  init: number;
}

export interface ReponseSugerenciasTDA {
  estado: boolean;
  torneosSugeridos: TorneosSugeridos[];
}

export interface TorneosSugeridos {
  idTorneoAmigos: number;
  nombre: string;
  nombreDuenio: string;
  cantidadParticipantes: number;
}

export interface TorneosAnteriores {
  estado: boolean;
  torneos_amigo_ant: TorneoAnterior[];
}

export interface TorneoAnterior {
  id: number;
  nombre: string;
  owner: boolean;
  supercopa: boolean;
  vip: boolean;
}

export type ActionsTourneys = {
  id: number;
  action?: 'accept' | 'reject';
};

// Create a type from the values
type StatusTypeTourney =
  (typeof STATUS_TOURNEY_INVITATION)[keyof typeof STATUS_TOURNEY_INVITATION];

export interface GenericItemTourneysData {
  id?: number;
  name?: string;
  title?: string | ReactNode;
  subtitle?: string;
  secundaryText?: number | string;
  textCentered?: ReactNode | number | string;
  disabled?: boolean;
  status?: StatusTypeTourney;
  isVip?: boolean;
  action?: {
    variantButton?: BaseButtonProps['variant'];
    txtAction: string;
    txtActionDisabled?: string;
  };
  titleIcon?: boolean;
  handleSubmit?: ({ id, action }: ActionsTourneys) => void;
  estadistica?: string;
  image?: string;
  variant?:
    | 'two-actions'
    | 'one-action'
    | 'show-status'
    | 'default'
    | 'with-image'
    | 'no-option';
  profilePicUrl?: string;
  withAvatar?: boolean;
  profileName?: string;
}

export interface ApplicationResponseTDA {
  estado: boolean;
  torneoInscripto: boolean;
  mensaje: string;
  codigo: number;
  idtorneo: number;
}

export interface ReponseFechasDisponiblesTDA {
  estado: boolean;
  fechas: DateGDT[];
}

export interface ReponseNombreDisponibleTDA {
  estado: boolean;
  nombreOk: boolean;
}

export interface ReponsePinesDisponiblesTDAVIP {
  estado: boolean;
  pin1: string;
  pin2: string;
}

export interface ReponseValidacionPinesTDAVIP {
  estado: boolean;
}

export interface ReponseConvertirTDAaVip {
  estado: boolean;
  convertidoOk: boolean;
}

export interface TdaInitialData {
  fechasDisponibles: DateGDT[];
}

export const enum EnumFriendsTournamentType {
  Common = 1,
  Vip = 2,
}

export interface ViewTDAResponse {
  estado: boolean;
  db_readOnly: boolean;
  fotoTda: FotoTda;
  isSupercopa: boolean;
  puntos_general: number;
  nombreGanadorFEORO: string;
  soyUltimaFecha: boolean;
  isParticipando: boolean;
  puntos_fecha: number;
  readOnly: boolean;
  ordenFC: number;
  top_general: TopRankingTDA[];
  nombre: string;
  posicion: number | string;
  deboChequearDBancTdaPremium: boolean;
  algunaFechaDelTAPublicada: boolean;
  portada?: ResponseCoverTda['portada'];
  top_fecha: TopRankingTDA[];
  podio: Podio;
  fechaCreacion: string;
  posicion_fecha: number | string;
  nombreFechaRanking: string;
  comenzo: boolean;
  estadisticasVip?: StatiticsTda;
  recordsTDA?: RecordsTda;
  vip?: boolean;
}

export interface Podio {
  champagne: Champagne;
  madera: Fairplay;
  fairplay: Fairplay;
  rustico: Fairplay;
}

export interface Champagne {
  nombre: string;
  apellido: string;
  nombreEquipo: string;
  idUsuario: number;
  puntos: number;
}

export interface Fairplay {
  nombre: string;
  apellido: string;
  nombreEquipo: string;
}

export interface TopRankingTDA {
  nombre: any;
  equipo: string;
  dt: string;
  puntos: number;
  vecesGanoFecha: number;
  modificoEquipo: boolean;
  idUsuarioDT: number;
  nroPos: number;
  diferenciaPosicion?: number;
  isGeneral?: boolean;
}

export interface ResponseRankingTda {
  estado: boolean;
  ordenFechaITDA: number;
  fechas: DateGDT[];
  fechasConRanking: DateGDT[];
}

export interface TourneyParamsUrl {
  id: number;
  inicio: number;
  vip: boolean;
  duenio: boolean;
}

export type DatosBancariosTO = {
  /**
   * id interno
   * Format: int32
   * @description  No usar.
   */
  id?: number;
  nombreTitular?: string;
  cuit?: string;
  nroCuenta?: string;
  banco?: string;
  /**
   * CBU
   * @description sólo numérico, 22 dígitos
   */
  cbu?: string;
  /**
   * última modificación de DB
   * Format: date-time
   */
  ultimaModificacion?: string;
};

export type ResponseObtenerDatosBancarios = {
  estado?: boolean;
  db?: DatosBancariosTO;
  /**
   * Datos bancarios no modificables
   * @description Ya no puede modificar sus datos bancarios. *DEPRECATED. devuelve siempre false*
   *     ver ELGRANDT-8687, comentario del 4/Ago/2017.
   */
  db_readOnly?: boolean;
  /**
   * duplicado, ignorar
   * @description  ver db_readOnly
   */
  readOnly?: boolean;
};

export type DatosBancariosBody = {
  nombreTitular: string;
  cuit: string;
  nroCuenta: string;
  banco: string;
  cbu: string;
};

export type TDAPost = {
  fecha: string;
  idMensaje: number;
  mensaje: string;
  nombre: string;
  fotoPerfil?: string;
};

export type ResponseGetPostsTDA = ResponseBase & {
  posts: TDAPost[];
};
export type ResponsePostPostsTDA = ResponseBase & {};
export interface RequestPostPostsTDA {
  tournamentId: number;
  message: string;
}
export interface ResponseCoverTda extends GDTApiErrors {
  portada: {
    idPortadaPredefinida?: number;
    offset?: number;
    pathImagen?: string;
  };
}

export interface ResponseProfilePic extends GDTApiErrors {
  fotoTda: FotoTda;
}

export interface FotoTda {
  idFotoPredefinida?: number;
  offset?: number;
  pathImagen?: string;
}

export interface ResponseAdminTda {
  paginaActualAcep: number;
  paginaActualPart: number;
  estado: boolean;
  cantPorPaginaAcep: number;
  torneoAmigos: string;
  fechaCreacionOrden: number;
  fechaCreacion: string;
  pagePart: Page;
  permModFecha: boolean;
  pageAcep: Page;
  edad: number;
  cantPorPaginaPart: number;
  pageInvitados: Page;
}

export interface Page {
  objectList: AdminItemInvitation[];
  pageCount: number;
  currentPage: number;
  hasNext: boolean;
  hasPrevious: boolean;
  pagerInfo: PagerInfo;
  objectCount: number;
}

export interface AdminItemInvitation {
  idUsuario: number;
  nombreYApellido: string;
  nombreEquipo: string;
  camiseta: string;
  fotoPerfil?: string;
  /**
   * Format: byte
   * @description Estado del usuario logueado dentro del torneo. <br>
   * Usado para saber si ya estás participando o si ya estás invitado.
   * <li> PENDIENTE_ACEPTAR_DUENIO( 1, "Pendiente Aceptar Dueño"),</li>
   * <li>PARTICIPANDO( 2, "Participando"),</li>
   * <li>ELIMINADO( 3, "Eliminado"), </li>
   * <li>PENDIENTE_ACEPTAR_INVITADO( 4, "Pendiente Aceptar Invitado"), </li>
   * <li>RECHAZADO( 5, "rechazado por el dueño"), </li>
   * <li>RECHAZA_INVITADO( 6, "Invitación rechazada por Invitado")</li>
   */
  idEstado: number;
}

export interface PagerInfo {
  length: number;
  init: number;
}

export interface StatiticsTda {
  jugadoresPorClub: ClubTda[];
  hinchasClub: ClubTda[];
}

export interface ClubTda {
  nombre: string;
  porcentaje: number;
}

export interface RecordsTda {
  mejor_ptj_historico: BestHistorics;
  peor_ptj_historico: BestHistorics;
  mejor_ptj_tda: BestTda;
  peor_ptj_tda: BestTda;
  mejor_ptj_historico_nombreEdicion: string;
  peor_ptj_historico_nombreEdicion: string;
}

export interface BestHistorics {
  edicion: number;
  puntaje: number;
  ordenFecha: number;
  idParticipante: number;
  nombreMostrar: string;
  offsetFechaEd: number;
}

export interface BestTda {
  ordenFecha: number;
  puntaje: number;
  idParticipante: number;
  nombreMostrar: string;
}

export type TAPorPremioTO = {
  /**
   * Nombre del TAP
   * @example Torneo de Amigos por Premios #420
   */
  nombre?: string;
  /**
   * id del TAP
   * Format: int32
   * @description usar para la inscripción.
   */
  id: number;
  /**
   * cantidad de participantes
   * Format: int32
   * @description cantidad de participantes ya inscriptos (0..20)
   */
  cantPart?: number;
  /**
   * tipo de pin asociado al tap/feoro
   * Format: int32
   * @description Alguno de estos ids: 	PIN_TAP_1(19,"Pin Especial TdA por Premios (1)", ""),//$200
   *     	PIN_TAP_2(20,"Pin Especial TdA por Premios (2)", ""),//$500
   *     	PIN_TAP_3(21,"Pin Especial TdA por Premios (3)", ""),//$1000
   *
   * @enum {integer}
   */
  idTipoPin?: 19 | 20 | 21;
  /** nombre de la fecha de inscripción */
  nombreFecha?: string;
  /**
   * Se uso el cupo gratuito (soc) de este TAP.
   * @description No usar. <br>Preferir el campo 'pinObligatorio' del servicio de datos de inscripción.<br>Antes permitía que el primer inscripto de cada TAP fuese gratuito. Ahora las reglas son más complicadas.
   */
  gratuitaFueUsada?: boolean;
  /**
   * premio del TAP
   * Format: int32
   * @description Premio en pesos del TAP
   */
  premio?: number;
  fechaInicio?: FechaTO;
  strPin?: string;
  usoPinDeCD?: boolean;
  tipoProducto: TipoProducto;
};

export type ParticipacionTapTo = {
  nombreTorneo: string;
  /**
   * id de TA
   * Format: int32
   */
  idTA: number;
  /**
   * Nombre del TAP
   * @example Torneo de Amigos por Premios #420
   */
  nombreTA?: string;
  /**
   * id del participante
   * Format: int32
   * @description NO es el id de usuario.  Es el id del registro de participación (registro de inscripción) en el TAP.
   */
  idParticipante?: number;
  /**
   * id del lote
   * Format: int32
   * @description Un lote es un conjunto de TAPs.
   *     <br>
   *     Todos los taps de un lote tienen:
   *       - la misma fecha de inicio
   *       - el mismo pin/premio
   *     <br> NO SE USA EN LA GUI.
   */
  idLote?: number;
  /**
   * id interno del PIN usado para la inscripción
   * Format: int32
   * @description Se usa para determinar si la inscripción fue gratuita.<br>  this.getIdPin() == null => fue gratuita<br> pero NO SE USA actualmente EN LA GUI.
   */
  idPin?: number;
  /**
   * tipo de pin asociado al tap
   * Format: int32
   * @description WM y App no lo usan. Seguramente hay otra manera de usar este dato. Alguno de estos ids: 	PIN_TAP_1(19,"Pin Especial TdA por Premios (1)", ""),//$200
   *     	PIN_TAP_2(20,"Pin Especial TdA por Premios (2)", ""),//$500
   *     	PIN_TAP_3(21,"Pin Especial TdA por Premios (3)", ""),//$1000
   *
   * @enum {integer}
   */
  tipoPinTA?: 19 | 20 | 21;
  /**
   * premio del TAP
   * Format: int32
   * @description Premio en pesos del TAP
   */
  premio?: number;

  fechaInicio: FechaTO;
};

type TipoProducto = {
  idTipoPin: number;
  idTipoProducto: number;
  precioDeLista: number;
};

export type ResponseListarTapsUsuario = {
  /**
   * true / false.
   * @description Indica si hubo un error o no.
   */
  estado?: boolean;
  /**
   * mensaje de error
   * @description si estado == false.
   */
  mensaje?: string;
  /**
   * código de error (opcional)
   * Format: int32
   * @description si estado == false.
   */
  codError?: number;
  /**
   * inscripciones del usuario
   * @description Lista participaciones del usuario en tap.
   */
  participaciones: ParticipacionTapTo[];
  /**
   * idem tieneDB
   * @description Tiene datos bancarios = lleno form de datos bancarios
   */
  llenoFormBancario?: boolean;
  /**
   * Datos bancarios no modificables
   * @description Ya no puede modificar sus datos bancarios.
   */
  db_readOnly?: boolean;
  /** idem db_readOnly (deprecated, duplicado) */
  readOnly?: boolean;
  /**
   * debo mostrar popup DB
   * @description Se puede mostrar popup de datos bancarios.. (feature flag, siempre habilitado) Configuración global. Ver T_CONFIGURACION_SP.a_clave = 'tdaPremios.popUp'
   */
  muestroPopUpDatosBancarios?: boolean;
  /**
   * torneos por premios abiertos
   * @description  Torneos con inscripción abierta y cupo disponible.
   */
  abiertos?: TAPorPremioTO[];
  /**
   * tenés pin tap usable
   * @description Busca si tenés un pin aceptable para alguno de los torneos abiertos.
   */
  tengoPinDisponible?: boolean;
};

export type ResponsePopupInscriptionData = {
  /**
   * true / false.
   * @description Indica si hubo un error o no.
   */
  estado?: boolean;
  /**
   * mensaje de error
   * @description si estado == false.
   */
  mensaje?: string;
  /**
   * código de error (opcional)
   * Format: int32
   * @description si estado == false.
   */
  codError?: number;
  /**
   * sigue abierto
   * @description Dice si el torneo seleccionado sigue abierto
   */
  estaAbierto?: boolean;
  /**
   * pin obligatorio
   * @description Indica si la inscripción gratuita es posible.
   */
  pinObligatorio?: boolean;
  /**
   * Lista de TAPs abiertos
   * @description Abierto = con inscripción abierta = tiene menos de 20 participantes y no estamos en veda.
   */
  abiertos?: TAPorPremioTO[];
  ta?: TAPorPremioTO;
  /**
   * pin sugerido
   * @description sólo si tiene un pin en la cuenta y la inscripción necesita un pin
   */
  pinSugerido?: string;
};

export type ResponseInscribirseTap = {
  /**
   * true / false.
   * @description Indica si hubo un error o no.
   */
  estado?: boolean;
  /**
   * mensaje de error
   * @description si estado == false.
   */
  mensaje?: string;
  /**
   * código de error (opcional)
   * Format: int32
   * @description si estado == false.
   */
  codError?: number;
  /**
   * ok
   * @description debería ser true si la inscripción fue exitosa
   */
  ok?: boolean;
};

export type tourneyModalState = {
  title: string;
  open: boolean;
  openSuccessModal: boolean;
  content: JSX.Element | null;
  loading?: boolean;
};

export interface Equipo {
  equipo: string;
  dt: string;
  puntos: number;
  vecesGanoFecha: number;
  modificoEquipo: boolean;
  idUsuarioDT: number;
  nroPos: number;
}

export type ResponseTapTourneyData = {
  algunaFechaDelTAPublicada?: boolean;
  /**
   * @description ver 'ver tda'
   * @example false
   */
  comenzo?: boolean;
  /**
   * @description deprecated
   * @example false
   */
  db_readOnly?: boolean;
  deboChequearDBancTdaPremium: boolean;
  /**
   * @description ver 'ver tda'
   * @example true
   */
  estado?: boolean;
  /**
   * @description ver 'ver tda'
   * @example "Fecha 3"
   */
  fechaCreacion?: string;
  /**
   * @description tipo de pin asociado al TDA (ver endpoint listar Taps del usuario)
   * @example 19
   */
  idTipoPin?: number;
  /**
   * @description ver 'ver tda'
   * @example true
   */
  isParticipando?: boolean;
  /**
   * @description ver 'ver tda'. siempre false en este caso.
   * @example false
   */
  isSupercopa?: boolean;
  /**
   * @description ver 'ver tda'
   * @example Torneo de Amigos por Premios #168
   */
  nombre?: string;
  /**
   * @description ver 'ver tda'
   * @example "Fecha 3"
   */
  nombreFechaRanking?: string;
  /**
   * @description ver 'ver tda'
   * @example 0
   */
  ordenFC?: number;
  /**
   * @description ver 'ver tda'
   * @example {}
   */
  podio?: string;
  /**
   * @description ver 'ver tda'
   * @example "-"
   */
  posicion?: string;
  /**
   * @description ver 'ver tda'
   * @example "-"
   */
  posicion_fecha?: string;
  /**
   * @description ver 'ver tda'
   * @example "-"
   */
  puntos_fecha?: string;
  /**
   * @description ver 'ver tda'
   * @example -
   */
  puntos_general?: string;
  /**
   * @description ver 'ver tda'
   * @example false
   */
  soyUltimaFecha?: boolean;
  /**
   * @description ver 'ver tda'
   * @example [{"equipo":"Los Juanes","dt":"juan perez","puntos":0,"vecesGanoFecha":0,"modificoEquipo":false,"idUsuarioDT":5342600,"nroPos":1}]
   */
  top_fecha?: Equipo[];
  /**
   * @description ver 'ver tda'
   * @example [{"equipo":"Los Juanes","dt":"juan perez","puntos":0,"vecesGanoFecha":0,"modificoEquipo":false,"idUsuarioDT":5342600,"nroPos":1}]
   */
  top_general?: Equipo[];
  vip: boolean;
  //ganasteF11 aparece cuando termina el torneo
  ganasteF11?: boolean;
  //nombre del ganador
  nombreGanadorGeneral: string;
};

export type FechaTO = {
  /**
   * id de fecha
   * Format: int32
   */
  id: number;
  /** nombre de fecha */
  nombre?: string;
  /**
   * orden de fecha
   * Format: int32
   */
  orden?: number;

  /**
   * fecha de inicio
   * Format: int32
   */
  ordenFC?: number;

  /**
   * idRnkPublicado
   * Format: int32
   * @description ojo, solo usar en GrupoCopaAmigos
   */
  idRnkPublicado?: number;
  publicada?: boolean;
  isPublicada?: boolean;
};

export interface TapAtomState {
  tourneyDate?: FechaTO;
  tourneyPrize?: number;
  tourneyId?: number;
  isOpenInfo?: boolean;
  llenoFormBancario?: boolean;
}
export type ResponseDatosBasicosTDA = {
  estado?: boolean;
  nombre?: string;
  nombreDuenio?: string;
  apellidoDuenio?: string;
  fechaInicio?: FechaTO;
  /**
   * Format: byte
   * @description Estado del usuario logueado dentro del torneo. <br>
   * Usado para saber si ya estás participando o si ya estás invitado.
   * <> 2 significa que no estás participando.
   * <li> PENDIENTE_ACEPTAR_DUENIO( 1, "Pendiente Aceptar Dueño"),</li>
   * <li>PARTICIPANDO( 2, "Participando"),</li>
   * <li>ELIMINADO( 3, "Eliminado"), </li>
   * <li>PENDIENTE_ACEPTAR_INVITADO( 4, "Pendiente Aceptar Invitado"), </li>
   * <li>RECHAZADO( 5, "rechazado por el dueño"), </li>
   * <li>RECHAZA_INVITADO( 6, "Invitación rechazada por Invitado")</li>
   */
  idEstadoParticipante?: string;
};

export type ResponseReactivarTorneoAnterior = {
  /**
   * true / false.
   * @description Indica si hubo un error o no.
   */
  estado: boolean;
  /**
   * mensaje de error
   * @description si estado == false.
   */
  mensaje?: string;
  /**
   * código de error (opcional)
   * Format: int32
   * @description si estado == false.
   */
  codError?: number;
  /**
   * @deprecated
   * @description (CUIDADO!) Es el nombre que mandaste en el request. Lo devuelve cuando hubo un error de (palabrasProhibidas o nombreTomado).
   */
  nombreTa?: string;
  /**
   * @deprecated
   * @description (deprecated) Es el nombre que mandaste en el request. Lo devuelve cuando NO hubo un error.
   */
  nombreTA?: string;
  /**
   * @description '1' si esta tomado el nombre
   * @enum {string}
   */
  nombreTomado?: '1' | '';
  /** @description SI (nombreTomado='1'), sugiere otro nombre */
  nombreSugerido?: string;
  /**
   * @description '1' si el nombre del TDA contiene palabras prohibidas. Importante: también setea 'nombreTomado' (el manejo de 'nombreTomado' suele ser el mismo)
   * @enum {string}
   */
  palabrasProhibidas?: '1' | '';
  /**
   * Format: int32
   * @description id del torneo creado, alias de 'idTaCreado'
   */
  idTorneo?: number;
  /**
   * Format: int32
   * @description id del torneo creado
   */
  idTaCreado?: number;
  /**
   * Format: int32
   * @description Pines disponibles. Frontend: util para actualizar header.
   */
  pinesDisponibles?: number;
  /** @description El usuario es premium?. Frontend: util para actualizar header. */
  premium?: boolean;
  /** @description saldo del usuario. Frontend: util para actualizar header. */
  saldo?: number;
  /** @description Ignorar. Funcionalidad no usada. */
  tiendaAuspiciante?: boolean;
};

export type RequestReactivarTorneoAnterior = {
  /**
   * @description 1=comun, 2=vip
   */
  vip: number;
  /**
   * @description alias de 'vip'
   * @example 1
   */
  tipo?: number;
  /**
   * @description nuevo nombre del TDA
   * @example unNombre
   */
  nombreTA?: string;
  /**
   * @description orden de fecha de inicio del nuevo TDA. 'Fecha 1' suele ser 0.
   * @example 9
   */
  ordenFechaInicioTDA?: number;
  /**
   * @description id del TdA ANTERIOR
   * @example 2
   */
  idTA?: number;
  /** @description obligatorio si no sos premium y querés crear un TdA VIP */
  pin1?: string;
  /** @description obligatorio si no sos premium y querés crear un TdA VIP */
  pin2?: string;
};

export interface ResponseReactivarMinileague {
  estado: boolean;
  miniLiga: {
    id: number;
    nombreML: string;
    idUsuarioOwner: number;
    fs: FechaTO[];
    cantidadParticipantes: number;
    idEstadoML: number;
    nombreAdm: string;
    apellidoAdm: string;
    isOwner: boolean;
  };
  mlXReact?: boolean;
  mlAnteriores?: any[];
  nombreTomado?: string;
}
